import { SVGProps } from "react";

const GreenTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#6EBD7F"
      d="M16.482 8.83a.752.752 0 0 0-1.057 0l-4.746 4.746-2.104-2.104a.752.752 0 0 0-1.057 0 .752.752 0 0 0 0 1.056l2.633 2.633a.747.747 0 0 0 1.057 0l5.274-5.275a.752.752 0 0 0 0-1.056Z"
    />
    <path
      fill="#6EBD7F"
      fillRule="evenodd"
      d="M12 1.95C6.456 1.95 1.95 6.456 1.95 12c0 5.544 4.506 10.05 10.05 10.05 5.544 0 10.05-4.506 10.05-10.05 0-5.544-4.506-10.05-10.05-10.05ZM3.446 12c0-4.717 3.838-8.555 8.554-8.555 4.717 0 8.555 3.838 8.555 8.555 0 4.716-3.838 8.555-8.555 8.555-4.716 0-8.554-3.838-8.554-8.555Z"
      clipRule="evenodd"
    />
  </svg>
);

export default GreenTick;
